import {reqWithToken} from './requestHelper';

export async function getWaitingForm(){
    return (await reqWithToken('api/gxbooking/review')).data;
}

export async function sign(todo){
    return (await reqWithToken('api/gxbooking/review/approve',{
        params: todo,
        method: 'put'
    })).data;
}

export async function signAll(ids){
    return (await reqWithToken('api/gxbooking/review/approveAll',{
        data: ids,
        method: 'patch'
    })).data;
}

export async function deny(reason){
    return (await reqWithToken('api/gxbooking/review/deny',{
        data: reason,
        method: 'patch',

    })).data;
}
